var XLSX = require('xlsx')
function generarExcel (data, titulo, opciones = {}) {
  let filename = titulo + '.xlsx'

  let pag = 'HOJA1'
  let datos = {}
  let cabeceras = []
  let filas = []
  let maximos = []
  if (opciones.nombres) {
    opciones.nombres.forEach((el, i) => {
      cabeceras.push(el[Object.keys(el)[0]])
      maximos.push({ wch: 10 })
    })
    filas.push(cabeceras)
    data.forEach(fila => {
      let indi = []
      opciones.nombres.forEach((el, i) => {
        fila[Object.keys(el)[0]] =
          fila[Object.keys(el)[0]] == null ? '' : fila[Object.keys(el)[0]]
        indi.push(fila[Object.keys(el)[0]])
        if (maximos[i].wch <= fila[Object.keys(el)[0]].length) {
          maximos[i].wch = fila[Object.keys(el)[0]].length + 5
        }
      })
      filas.push(indi)
    })
  } else {
    Object.keys(data[0]).forEach(el => {
      if (el !== 'id') {
        cabeceras.push(titleCase(el.replace(/_/g, ' ')))
        maximos.push({ wch: 10 })
      }
    })
    filas.push(cabeceras)
    data.forEach(fila => {
      let indi = []
      Object.keys(data[0]).forEach((el, i) => {
        if (el !== 'id') {
          if (fila[el] == null) {
            fila[el] = ''
          }
          indi.push(fila[el])
          let index = Object.keys(data[0]).includes('id') ? i - 1 : i
          if (maximos[index].wch <= fila[el].length) {
            maximos[index].wch = fila[el].length + 5
          }
        }
      })
      filas.push(indi)
    })
  }
  datos[pag] = filas

  let wb = XLSX.utils.book_new()

  let ws = XLSX.utils.aoa_to_sheet(datos[pag])

  ws['!cols'] = maximos

  XLSX.utils.book_append_sheet(wb, ws, pag)

  XLSX.writeFile(wb, filename)
}

function titleCase (str) {
  let splitStr = str.toLowerCase().split(' ')
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(' ')
}

export default {
  generarExcel
}



// WEBPACK FOOTER //
// ./src/utils/generar_excel.js